<div class="compliance-overview flex-column d-flex gap-4" *transloco="let t; prefix: 'compliance.overview'">
  <div class="compliance-overview__header">
    <div class="header">
      <h2 class="h3 m-0">{{ t('title') }}</h2>
    </div>
		<div>
			<app-compliance-filters
				[hasAssetTypesBtn]="activeTab === 'routineComplianceTasks'"
				[hasComplianceCalendarBtn]="activeTab === 'routineComplianceTasks'"
				[hideSearchInput]="activeTab === 'periodicComplianceTasks' || activeTab === 'routineComplianceTasks'">
			</app-compliance-filters>
		</div>
  </div>

	<div class="row">
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-non-compliant-widget></app-non-compliant-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-expiring-soon-widget></app-expiring-soon-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-compliant-widget></app-compliant-widget>
		</div>
		<div class="col-lg-3 col-md-6 col-sm-12">
			<app-inspection-pass-rate-widget></app-inspection-pass-rate-widget>
		</div>
	</div>

	<div class="cmn_tabWrap">
		<div class="cmn_tabWrapUl">
    	<ul class="nav nav-pills" id="pills-tab" role="tablist">
      	<li class="nav-item" role="presentation">
        	<button class="nav-link active" [class.active]="activeTab === 'complianceOverviewDetails'" 
						id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home"
          	type="button" role="tab" aria-controls="pills-home" aria-selected="true"
          	(click)="toggleTab('complianceOverviewDetails')">
						{{ t('tabs.overview') }}
					</button>
      	</li>
      	<li class="nav-item" role="presentation">
        	<button class="nav-link" [class.active]="activeTab === 'periodicComplianceTasks'" 
						id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
          	type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
          	(click)="toggleTab('periodicComplianceTasks')">
						{{ t('tabs.periodic') }}
					</button>
      	</li>
				<li class="nav-item" role="presentation">
        	<button class="nav-link" [class.active]="activeTab === 'routineComplianceTasks'" 
						id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile"
          	type="button" role="tab" aria-controls="pills-profile" aria-selected="false"
          	(click)="toggleTab('routineComplianceTasks')">
						{{ t('tabs.routine') }}
					</button>
      	</li>
    	</ul>
  	</div>
	</div>
	<div class="tab-content-wrapper">
  	@switch(activeTab) {
    	@case('complianceOverviewDetails') {
    		<app-compliance-overview-details></app-compliance-overview-details>
    	}
    	@case('periodicComplianceTasks') {
    		<app-periodic-compliance-tasks></app-periodic-compliance-tasks>
    	}
    	@case('routineComplianceTasks') {
    		<app-routine-compliance-tasks></app-routine-compliance-tasks>
    	}
  	}
	</div>
</div>